import React from 'react';
import { Link } from 'react-router-dom';
import { green, neutral } from '../styles/colors';

const NIMBLY_LOGO_URL =
	'https://i0.wp.com/hellonimbly.com/wp-content/uploads/2022/02/Nimbly-Main-Logo-Green.png?w=3662&ssl=1';

export default class NotFound extends React.Component {
	render() {
		return (
			<div
				className="page-root"
				style={{
					height: '100vh',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					gap: '20px',
					backgroundColor: neutral[200],
					padding: '20px',
				}}
			>
				<img
					src={NIMBLY_LOGO_URL}
					alt="Nimbly"
					style={{
						width: 300,
						height: 'auto',
						marginBottom: '16px',
					}}
				/>
				<h1
					style={{
						fontSize: 72,
						fontWeight: 700,
						color: green[800],
						margin: 0,
						letterSpacing: '-2px',
					}}
				>
					404
				</h1>
				<h2
					style={{
						fontSize: 24,
						fontWeight: 600,
						color: neutral[900],
						margin: 0,
						textAlign: 'center',
					}}
				>
					Oops! Page Not Found
				</h2>

				<Link
					to="/"
					style={{
						marginTop: '16px',
						padding: '14px 32px',
						backgroundColor: green[800],
						color: '#fff',
						borderRadius: '8px',
						textDecoration: 'none',
						fontSize: 16,
						fontWeight: 600,
						boxShadow: '0 4px 14px rgba(0, 171, 78, 0.4)',
						transition: 'all 0.2s ease',
					}}
					onMouseOver={(e) => {
						e.currentTarget.style.backgroundColor = green[700];
						e.currentTarget.style.transform = 'translateY(-2px)';
						e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 171, 78, 0.5)';
					}}
					onMouseOut={(e) => {
						e.currentTarget.style.backgroundColor = green[800];
						e.currentTarget.style.transform = 'translateY(0)';
						e.currentTarget.style.boxShadow = '0 4px 14px rgba(0, 171, 78, 0.4)';
					}}
				>
					Take Me Home
				</Link>
			</div>
		);
	}
}
